export const baseUrl = "https://faraday-admin.arachnomesh.com/"
// export const imageUrl= "https://faraday-admin.arachnomesh.com/"
export const imageUrl2= "https://faraday-admin.arachnomesh.com/"
export const imageUrl= "https://admin.fabricationbazar.com/"